import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  pageTitle: {
    fontSize: 26,
    fontWeight: 300
  },
  pageContentDIv: {
    //marginTop:30,
    //padding:'41px 40px',
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  formTitle: {
    fontSize: 16,
    fontWeight: 300,
    marginBottom: 16
  },
  formRoot: {
    width: '100%'
  },
  formMargin: {
    margin: theme.spacing(1),
    width: '100%',
    minWidth: '400px',
    maxWidth: '400px'
  },
  formCard: {
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    boxShadow: 'none',
    padding: '30px 30px',
    paddingBottom: 0,
    '& .MuiCardHeader-root': {
      padding: '0 0',
      marginBottom: 8
    },
    '& .MuiFormControl-root': {
      width: '100%',
      maxWidth: 400,
      minWidth: 400
    },
    '& .MuiFormControl-fullWidth': {
      //maxWidth:'100% !important'
    }
  },
  formCardContent: {
    padding: 0,
    height: 'calc(100vh - 266px)',
    overflow: 'auto'
  },
  formCardActions: {
    backgroundColor: '#fcfcfc',
    marginRight: -30,
    marginLeft: -30,
    justifyContent: 'flex-end',
    padding: 24,
    borderTop: '1px solid #eaedf3'
  },
  partyListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%'
  },
  partyAddListItem: {
    padding: '12px 15px',
    margin: 0,
    backgroundColor: '#0b1323',
    color: '#fff',
    fontWeight: 300,
    minHeight: 46,
    width: '100%',
    maxHeight: 46
  },
  listBoxAutoCompelete: {
    margin: 0,
    padding: 0
  },
  listBoxOption: {
    padding: 0,
    minHeight: 46,
    maxHeight: 46,
    borderBottom: '1px solid #eaedf3',
    "&:first-child": {
    },
    "&:last-child": {
    }
  },
  vehicleListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%',
    display: 'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  divVehicleListing: {
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
  },
  vehicleNumberSuffix: {
    marginLeft: 3,
    color: "#0033cc",
    marginRight: 3,
    fontWeight: 300
  },
  addPersonIcon: {
    color: '#fff',
    marginRight: 10
  },
  cherveRightIcon: {
    marginLeft: 10,
    float: 'right',
    color: '#fff'
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  vehicleListItemFlex:{
      display:'flex',
      alignItems:'center',
      flexDirection:'row'
  },
  ownershipType: {
    marginLeft: 'auto',
    width: 70,
    textAlign: 'right',
    fontWeight: 'bold'
  },
  listBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 6,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  avilableBullet: {
    borderRadius: "50%",
    backgroundColor: "#2d9d78",
    fontSize: 6,
    color: "#2d9d78",
    margin: "0px 6px",
    marginTop: -2
  },
  onTripBullet: {
    borderRadius: "50%",
    backgroundColor: "#2d9d78",
    fontSize: 6,
    color: "#2d9d78",
    margin: "0px 6px",
    marginTop: -2
  },
  listRight: {
    float: 'right'
  },
  vehicleNumberSuffix: {
    marginLeft: 3,
    color: "#00875a",
    marginRight: 3,
    fontWeight: 700
  },
  own: {
    padding: "2px 10.5px",
    borderRadius: 3,
    margin: '0px 8px',
    fontSize: 11,
    color: "#fff",
    backgroundColor: '#0033cc'
  },
  hired: {
    padding: "2px 10.5px",
    borderRadius: 3,
    margin: '0px 8px',
    fontSize: 11,
    color: "#fff",
    backgroundColor: '#e86825'
  },
  vehicleStatus: {
    fontSize: 12,
    textTransform: 'capitalize',
  },
  vehicleStatus: {
    fontSize: 12,
    width:'100%',
    textTransform: 'capitalize',
    alignItems:'center',
    display:'flex',
    justifyContent:'space-between'
  },
  inputsTitle: {
    padding: '0 0',
    marginBottom: 8,
    fontWeight: 700
  },
  inlineInput: {
    display: 'flex',
  },
  billingTypeRadio: {
    maxWidth: '100% !important',
    '& .MuiFormControl-fullWidth': {
      //maxWidth:'100% !important'
    },
    '& .MuiFormControlLabel-root': {
      //marginRight:0
    },
    '& .MuiRadio-root': {
      //display:'none'
    }
  },
  titleV1: {
    fontSize: 12,
    color: '#9ea0a5',
    marginBottom: 6,
    fontWeight:600
  },
  billingTypeLabel: {
    height: 36,
    padding: '10px 12px',
    borderRadius: 4
  },
  continue: {
    letterSpacing: '1px', color: 'white', backgroundColor: '#0033cc', textTransform: 'none', fontWeight: 'bold', paddingTop: '6px', paddingBottom: '7px', paddingLeft: '26px', paddingRight: '26px', fontSize: '15px', marginTop: '10px',
    "&:hover": {
      backgroundColor: '#0033cc'
    }
  },
  receiptIcon: {
    color: 'white', width: '1.3em', height: '1.3em', marginTop: '-1px',
  },
  confirmV1: {
    backgroundColor: 'black',
    color: 'white',
    textTransform: 'capitalize',
    fontWeight: 300,
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 9,
    paddingBottom: 11,
    "&:hover": {
      backgroundColor: 'black'
    }
  },
  cancelButton: {
    textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
    "&:hover": {
      backgroundColor: '#f6f7f9'
    }
  },
  divV1: {
    display: 'flex', alignItems: 'center', backgroundColor: 'black', width: '100%', paddingLeft: '12px', justifyContent: 'space-between', paddingRight: '15px'
  },
  divV2: {
    display: 'flex', alignItems: 'center'
  },
  divV3: {
    display: 'flex', flexDirection: 'column', marginLeft: '6px', fontWeight: 300
  },
  divV4: {
    letterSpacing: '0.03em', color: 'white'
  },
  divV5: {
    fontSize: 13, color: 'white'
  },
  divV6: {
    paddingLeft: '12px', fontWeight: 300
  },
  closeButton: {
    fontSize: 18,
    color: '#e0e0e0',
  },
  dialogTitleV1: {
    paddingLeft: 30, paddingTop: 16, paddingBottom: '16px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiTypography-root': {
      width: '100%'
    }
  },
  divV20: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight:600
  },
  dialogContentV1: {
    paddingLeft: 30, paddingTop: 24, paddingRight: 30
  },
  marginV1: {
    margin: 0, marginTop: 6
  },
  marginV2: {
    margin: 0, marginTop: 12
  },
  divAmount: {
    fontSize: 12, color: '#9ea0a5', fontWeight: 500
  },
  divReason: {
    color: '#9ea0a5', fontSize: 12, fontWeight: 500, marginBottom: '-9px', marginTop: 16
  },
  divDate: {
    color: '#9ea0a5', fontSize: 12, fontWeight: 500, marginTop: 16
  },
  divV7: {
    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: '21px'
  },
  mtV1: {
    marginTop: '24px'
  },
  dialogTitleV2: {
    paddingLeft: 22,
    paddingRight: 22,
    paddingTop: 12,
    paddingBottom: 12,
    "& .MuiTypography-root": {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  fw300: {
    fontWeight: 300,
  },
  driverName: {
    fontSize: 14, color: '#9ea0a5', fontWeight: 500, marginBottom: '-9px'
  },
  mtV2: {
    marginTop: 16
  },
  eventIcon: {
    color: 'grey'
  },
  billingTypeLabelSelected: {

  },
  billingTypeLabelUnSelected: {

  },
  disableCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#efeff2',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3e3f42',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em'
  },
  saveCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#161f34',
    fontSize: 14,
    fontWeight: 300,
    color: 'white',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    '&:hover': {
      backgroundColor: '#161f34',
    }
  }
}));
export default useStyles;